/**
 * Route constants for the places whose LABEL and PATH disagree.
 *
 * There is exactly one of those today, and it has already cost a bug:
 * the surface a studio calls "Passport" is routed at `/galaxy` (the
 * page was named for the planet collection before the feature was
 * named for the book it lives in). Writing `/passport` is the natural
 * thing to do and produces a silent 404 — which, on the last step of
 * signup, is the worst possible place for one.
 *
 * Anything whose label and path already match does NOT belong here.
 * A constant per route is a second source of truth to keep in sync;
 * this file is only for the ones where the obvious guess is wrong.
 */

/** Passport — the studio's planets. Labelled Passport, routed /galaxy. */
export const PASSPORT_PATH = '/galaxy';
